<template>
  <div class="loons">
    <img src="@/assets/promo/loons_promo.png" alt="Doubloons" class="promo">
    <a href="https://www.amazon.com/Created-By-Intelligent-Design-Jackaloons/dp/B009KLU230/ref=sr_1_6?dchild=1&qid=1598738759&refinements=p_4%3ACreated+By+Intelligent+Design&s=mobile-apps&search-type=ss&sr=1-6">
      <img src="@/assets/buttons/amazon-kindlefire-white_badge.png" alt="">
    </a>
    <br><br>
    <h2>Match The Faces!</h2>
    <h2>...If You Dare.!</h2>
    <br>
    <p class="app-blurb">Collect all the faces to get your treats, but beware the Halloween tricks!
      A classic game with a twist.
    </p>
    <br><br>
    <img src="@/assets/screenshots/loons_01.png" alt="">
    <img src="@/assets/screenshots/loons_02.png" alt="">
    <img src="@/assets/screenshots/loons_03.png" alt="">
    <img src="@/assets/screenshots/loons_04.png" alt="">
    <img src="@/assets/screenshots/loons_05.png" alt="">
    <img src="@/assets/screenshots/loons_06.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'loons',
  computed: {
    factor () {
      return window.innerWidth / 1280
    },
    embedHeight () {
      return {
        height: 566 * this.factor + 'px'
      }
    }
  }
}
</script>

<style scoped>
.loons {
  background-color: cornflowerblue;
  color: white;
  font-weight: 800;
  font-size: 1.2em;
}
.loons img {
  margin: 0 10px;
}
.promo {
  margin: 0 !important;
  width: 100%;
}

h2 {
  width: 80%;
  margin: auto;
}
iframe {
  width: 100%;
}
</style>
